import React, { useCallback, useMemo, useState, useContext } from 'react';
import axios from 'axios';
import { Portal } from 'react-portal';
import { UserContext } from '../../../contexts/UserContext';
import DetailsModal from '../../batches/Details/DetailsModal';
import Button from 'components/bronson/Button';
import SellService from '../../../services/SellService';
import Globals from '../../../Globals';

const VehicleDetailsDownloadLink = ({ vehicle, t, cookies }) => {
    const { user, preferences, setPreferences } = useContext(UserContext);
    const [loading, setLoading] = useState();
    const [error, setError] = useState();
    const { circulationOptions, technicalDataOptions, billDataOptions } =
        useMemo(
            () => ({
                circulationOptions: {
                    text: t.getTraduction('CarLicence'),
                    id: t.getTraduction('CarLicence'),
                    name: 'Pcirc',
                    type: 'button',
                    icon: {
                        title: 'download',
                        image: 'semantic-download',
                        isAfterText: true,
                    },
                    class: 'c-btn  c-btn--secondary  c-btn--icon u-mr',
                    loading: loading === t.getTraduction('CarLicence'),
                    disabled: loading === t.getTraduction('CarLicence'),
                },
                technicalDataOptions: {
                    text: t.getTraduction('DataSheet'),
                    id: t.getTraduction('DataSheet'),
                    name: 'FiTec',
                    type: 'button',
                    icon: {
                        title: 'download',
                        image: 'semantic-download',
                        isAfterText: true,
                    },
                    class: 'c-btn  c-btn--secondary  c-btn--icon u-mr',
                    loading: loading === t.getTraduction('DataSheet'),
                    disabled: loading === t.getTraduction('DataSheet'),
                },
                billDataOptions: {
                    text: t.getTraduction('BillDownload'),
                    id: t.getTraduction('BillDownload'),
                    name: 'Bill',
                    type: 'button',
                    icon: {
                        title: 'download',
                        image: 'semantic-download',
                        isAfterText: true,
                    },
                    class: 'c-btn  c-btn--secondary  c-btn--icon u-mr',
                    loading: loading === t.getTraduction('BillDownload'),
                    disabled: loading === t.getTraduction('BillDownload'),
                },
            }),
            [t, loading]
        );

    const handleDownload = useCallback(
        async e => {
            e.preventDefault();
            const { name: fileName, id } = e.target;
            setLoading(id);
            const PradillaResponse = {
                Formato: null,
                Contenido: null,
            };
            try {
                const body = {
                    username: process.env.REACT_APP_PRADILLA_USER,
                    password: btoa(process.env.REACT_APP_PRADILLA_PASSWORD),
                };
                const config = {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(''),
                };
                const response = await axios
                    .post(
                        `${process.env.REACT_APP_PRADILLA_VEHICLE_DATA}/${vehicle.Plate}/${fileName}`,
                        JSON.stringify(body),
                        config
                    )
                    .then(response => {
                        PradillaResponse.Formato = response.data.Formato;
                        PradillaResponse.Contenido = response.data.Contenido;
                    });
                console.log(PradillaResponse);
                var sliceSize = 2000;
                var byteCharacters = window.atob(PradillaResponse.Contenido);
                var byteArrays = [];

                for (
                    var offset = 0;
                    offset < byteCharacters.length;
                    offset += sliceSize
                ) {
                    var slice = byteCharacters.slice(
                        offset,
                        offset + sliceSize
                    );
                    var byteNumbers = new Array(slice.length);

                    for (var i = 0; i < slice.length; i++) {
                        byteNumbers[i] = slice.charCodeAt(i);
                    }
                    var byteArray = new Uint8Array(byteNumbers);
                    byteArrays.push(byteArray);
                }
                var signatures = {
                    JVBERi0: "application/pdf",
                    R0lGODdh: "image/gif",
                    R0lGODlh: "image/gif",
                    iVBORw0KGgo: "image/png",
                    TU0AK: "image/tiff",
                    "/9j/": "image/jpg"
                  };
        
                    for (var s in signatures) 
                    {
                        if (PradillaResponse.Contenido.indexOf(s) === 0) 
                        {
                            var x = signatures[s];

                            PradillaResponse.Formato=x;
                            break;
                        }
                    }
                var blob = new Blob(byteArrays, {
                    type: PradillaResponse.Formato,
                });
                var fileURL = URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.style = 'display: none';
                a.href = fileURL;
                a.download =
                    fileName == 'FiTec'
                        ? 'Ficha_Tecnica'
                        : 'Permiso_Circulacion';
                a.click();
                window.URL.revokeObjectURL(fileURL);
                a.remove();
            } catch (error) {
                setError({
                    Content: t.getTraduction('DownloadDocumentationError')(
                        fileName,
                        vehicle.Plate
                    ),
                });
            } finally {
                setLoading(null);
            }
        },
        [vehicle.Plate, t]
    );

    const handleDownloadBill = useCallback(
        async e => {
            e.preventDefault();
            const { name: fileName, id } = e.target;
            setLoading(id);
            try {
                const response = await new SellService().getBillVehicle(
                    cookies.get(Globals.COOKIES.JWT).AccessToken,
                    {
                        NIF: vehicle.BuyerNumDocument,
                        Plate: vehicle.Plate,
                    }
                );
                if (response) {
                    var model = JSON.parse(JSON.parse(response.body).Result);
                    var sliceSize = 2000;
                    var byteCharacters = window.atob(model.File);
                    var byteArrays = [];

                    for (
                        var offset = 0;
                        offset < byteCharacters.length;
                        offset += sliceSize
                    ) {
                        var slice = byteCharacters.slice(
                            offset,
                            offset + sliceSize
                        );
                        var byteNumbers = new Array(slice.length);

                        for (var i = 0; i < slice.length; i++) {
                            byteNumbers[i] = slice.charCodeAt(i);
                        }
                        var byteArray = new Uint8Array(byteNumbers);
                        byteArrays.push(byteArray);
                    }
                    var blob = new Blob(byteArrays, {
                        type: 'application/pdf',
                    });
                    var fileURL = URL.createObjectURL(blob);
                    var a = document.createElement('a');
                    document.body.appendChild(a);
                    a.style = 'display: none';
                    a.href = fileURL;
                    a.download = 'Factura-' + vehicle.Plate + '.pdf';
                    a.click();
                    window.URL.revokeObjectURL(fileURL);
                    a.remove();
                    // device detection
                    // window.open(fileURL);
                }
            } catch (error) {
                setError({
                    Content: t.getTraduction('BillDownloadError')(
                        vehicle.Plate
                    ),
                });
            } finally {
                setLoading(null);
            }
        },
        [vehicle.Plate, t]
    );

    if (!vehicle.BuyerName) return null;

    return (
        <div className="u-mt u-flex u-flex-ch">
            <Button options={circulationOptions} onClick={handleDownload} />
            <Button options={technicalDataOptions} onClick={handleDownload} />
            <Button options={billDataOptions} onClick={handleDownloadBill} />
            <Portal>
                <DetailsModal
                    visible={error}
                    large={false}
                    onActionPress={() => setError(null)}
                    onClose={() => setError(null)}
                    title={t.getTraduction('DownloadDocumentationTitleError')}
                    content={error?.Content}
                    leftButton={t.getTraduction('Close')}
                />
            </Portal>
        </div>
    );
};

export default VehicleDetailsDownloadLink;
